import React, { FC } from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'

import { StoreList } from './StoreList'
import { StoreEdit } from './StoreEdit'

interface Props {

}

export const StorePage: FC<Props> = () => {
    const { path } = useRouteMatch()

    return (
        <Switch>
            <Route exact path={path} component={StoreList}/>
            <Route exact path={`${path}/edit/:id`} component={StoreEdit}/>
        </Switch>
    )
}